import type { AppPermission } from "../index.ts";
import { RESOURCE_MODULE_CATALOG } from "./module-catalog.ts";

/**
 * belora-admin starter set (BEL-494 / ADR-035 §6) — derived, not hardcoded:
 * write permissions of every customer-plane module. Platform-plane modules
 * (settings.customers) are explicitly excluded — those require platform_admin.
 */
export const CUSTOMER_PLANE_STARTER_PERMISSIONS: AppPermission[] = Array.from(
  new Set(
    Object.values(RESOURCE_MODULE_CATALOG)
      .filter((entry) => entry.plane === "customer")
      .flatMap((entry) => entry.levels.write),
  ),
);
